import React from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';

import {SearchBar, Button, USER_PERMISSIONS, PRODUCT_PERMISSIONS} from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const TeamOptions = ({ isReadingTeams, isReadingUserProductLimts }) => {
    const navigate = useNavigate();
    const [query] = useSearchParams();
    const search = query.get('search') || '';

    const encodedValue = value => encodeURIComponent(value);
    const searchFunction = (value)=> navigate(`/settings/teams?search=${encodedValue(value)}`);
    const cancelFunction = ()=> navigate(`/settings/teams`);
    
    return (
        <div className="TeamOptions">
            <SearchBar
                isSearching={isReadingTeams}
                search={search}
                searchFcn={searchFunction}
                cancelFcn={cancelFunction}
                placeholder={"Search for a team name"}
                bottomError
            />
            <RestrictedView
                type="disabled"
                userPermission={USER_PERMISSIONS.TEAMS_ADD}
                productPermission={PRODUCT_PERMISSIONS.SETTINGS_TEAMS}
            >
                <Button as={Link} to="/settings/add-team" primary disabled={isReadingUserProductLimts}>
                    <Icon name="plus" /> New Team
                </Button>
            </RestrictedView>
        </div>
    );
}

const mapStateToProps = state => ({
    isReadingTeams: state.teams.isReadingTeams,
    isReadingUserProductLimts: state.user.isReadingUserProductLimts,
});

export default connect(mapStateToProps, null)(TeamOptions);
